import React from 'react';

function NxlMobileNav({ activeSection, setActiveSection }) {
  const tabs = [
    { key: 'markets', label: 'Markets' },
    { key: 'hot', label: 'Hot' },
    { key: 'ticket', label: 'Ticket' },
    { key: 'positions', label: 'Positions' },
    { key: 'rules', label: 'Rules' },
  ];

  return (
    <nav className="nxl-mobile-nav" aria-label="NXL dashboard sections">
      {tabs.map((tab) => (
        <button
          key={tab.key}
          className={activeSection === tab.key ? 'active' : ''}
          onClick={() => setActiveSection(tab.key)}
        >
          {tab.label}
        </button>
      ))}
    </nav>
  );
}

export default NxlMobileNav;